import Gallery from '@components/Gallery';
import { useCreativesSlides } from '@components/Gallery/hooks';

import type { ICreativesSectionContentProps } from './types';

import style from './styles.module.scss';

const CreativesSectionContent = ({ creativesData }: ICreativesSectionContentProps) => {
  const slides = useCreativesSlides(creativesData);

  return (
    <div className={style.wrapper}>
      <div className="section-header">
        <h3 className="section-subtitle">Campaign Review</h3>
        <h1 className="section-title">CREATIVES</h1>
      </div>
      <div className={style['gallery-wrapper']}>
        <Gallery slides={slides} />
      </div>
    </div>
  );
};

export default CreativesSectionContent;
